import { Dialog } from '@react/components';
import { useTranslations } from '@react/lib/i18n';
import React from 'react';
export var DiscardConversationPrompt = function (_a) {
    var isOpen = _a.isOpen, onDiscard = _a.onDiscard, onCancel = _a.onCancel;
    var t = useTranslations().t;
    return (React.createElement(Dialog, { isOpen: isOpen, titleText: t.NewMessage.DiscardTitle, contentText: t.NewMessage.DiscardDescription, acceptButtonText: t.NewMessage.Confirm, cancelButtonText: t.NewMessage.Cancel, onAccept: onDiscard, onCancel: onCancel, maxWidth: "xs", fullWidth: true }));
};
